import { UIMessageStatus } from "../../enums";
export function isLoading(props) {
    return props === UIMessageStatus.Waiting ? true : undefined;
}
export function isRejected(props) {
    return props === UIMessageStatus.Error ? true : undefined;
}
//# sourceMappingURL=GetMsgType.js.map